// Api Flex Focus : 3002
import axios from "axios";
import { setupInterceptors } from "../modules/auth/services/tokenManager";
import { API_URL, AUTH_API_URL } from "../constants/config";
export const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
setupInterceptors(apiClient, AUTH_API_URL);
